import React, { Component } from "react";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import Modal from "./components/modal/modal";
import Dropdown from "./components/dropdown/dropdown";
import Domains from "./components/domains/domains";
import TextInput from "./components/textinput/textInput";
import NKInput from "./components/textinput/nKInput";
import { produce } from "immer";
import { outfile, regexCenterLat, lonIcoRotation } from "./regex/REGEX.js";
import { FiExternalLink } from "react-icons/fi";
import "./App.css";
import "./components/domains/icontools/icontools.css";
import Templates from "./components/templates/templates";
import Request from "./components/request/request";
import Sidebar from "./components/sidebar/sidebar";

class App extends Component {
    state = {
        showModal: false,
        twoDView: false,
        darkmode: localStorage.getItem("darkmode") === "true" || false,
        advancedmode: localStorage.getItem("advancedmode") === "true" || false,

        //json for request

        //zonda
        available_extpar_tags: [],
        extpar_tag: "",

        //basegrid
        keep_basegrid_files: false,
        grid_root: 13,
        grid_level: 4,
        outfile: "my_domain",
        icorotation: 0.0,
        icopole_lat: 90,
        icopole_lon: 0.0,

        domains: [
            {
                domain_id: 1,
                icontools: {
                    parent_id: 0,
                    region_type: 3,
                    center_lat: 49.5,
                    center_lon: 11.5,
                    hwidth_lat: 22.5,
                    hwidth_lon: 33.5,
                    lrotate: false,
                    pole_lat: 90,
                    pole_lon: -180,
                },
                extpar: {
                    use_array_cache: false,
                    iaot_type: 1,
                    ilu_type: 1,
                    ialb_type: 1,
                    isoil_type: 1,
                    itopo_type: 1,
                    it_cl_type: 1,
                    iera_type: 1,
                    iemiss_type: 1,
                    lradtopo: false,
                    enable_cdnc: false,
                    enable_edgar: false,
                    radtopo_radius: 40000.0,
                    nhori: 24,
                    enable_art: false,
                    l_use_corine: false,
                    ilookup_table_lu: 1,
                },
            },
        ],
    };

    updateState = (newState) => {
        this.setState(newState);
    }

    updateStateField = (field, value) => {
        this.setState((prevState) => ({ ...prevState, [field]: value }));
    };

    setIcontoolsField = (domainIndex, field, newValue) => {
        this.setState(
            produce((draft) => {
                draft.domains[domainIndex].icontools[field] = newValue;
            }),
        );
    }

    setExtparField = (domainIndex, field, newValue) => {
        this.setState(
            produce((draft) => {
                draft.domains[domainIndex].extpar[field] = newValue;
            }),
        );
    }

    removeIcontoolsField = (domainIndex, field) => {
        this.setState(
            produce((draft) => {
                delete draft.domains[domainIndex].icontools[field];
            })
        );
    }

    removeExtparField = (domainIndex, field) => {
        this.setState(
            produce((draft) => {
                delete draft.domains[domainIndex].extpar[field];
            })
        );
    }

    addDomain = () => {
        this.setState(
            produce((draft) => {
                if (draft.domains[draft.domains.length - 1].icontools.region_type === 1) {
                    draft.domains.push({
                        domain_id: 1,
                        icontools: {
                            parent_id: 0,
                            region_type: 3,
                            center_lat: 49.5,
                            center_lon: 11.5,
                            hwidth_lat: 22.5,
                            hwidth_lon: 33.5,
                        },
                        extpar: {
                            use_array_cache: false,
                            iaot_type: 1,
                            ilu_type: 1,
                            ialb_type: 1,
                            isoil_type: 1,
                            itopo_type: 1,
                            it_cl_type: 1,
                            iera_type: 1,
                            iemiss_type: 1,
                            lradtopo: false,
                            enable_cdnc: false,
                            enable_edgar: false,
                            radtopo_radius: 40000.0,
                            nhori: 24,
                            enable_art: false,
                            l_use_corine: false,
                            ilookup_table_lu: 1,
                        },
                    }
                    );
                } else {
                    draft.domains.push({
                        ...draft.domains[draft.domains.length - 1],
                        domain_id: draft.domains[draft.domains.length - 1].domain_id + 1,
                        icontools: {
                            ...draft.domains[draft.domains.length - 1].icontools,
                            parent_id: draft.domains[draft.domains.length - 1].icontools.parent_id + 1,
                        }
                    });
                }
            }),
        );
    };

    removeDomain = (index) => {
        if (index > 0) {
            this.setState(
                produce((draft) => {
                    draft.domains.splice(index, 1);
                }),
            );
        }
    };


    closeModal = () => {
        this.setState({ showModal: false });
    };

    toggleDarkmode = () => {
        this.setState((prevState) => ({
            ...prevState,
            darkmode: !prevState.darkmode,
        }));
        localStorage.setItem("darkmode", JSON.stringify(!this.state.darkmode));
    };

    componentDidMount() {
        const extpar_tags = process.env.REACT_APP_EXTPAR_TAGS?.split(" ");
        this.updateStateField("available_extpar_tags", extpar_tags ? extpar_tags : ["GETTING EXTPAR TAGS FAILED!"])
        this.updateStateField("extpar_tag", extpar_tags[0])
    }

    toggleAdvancedmode = () => {
        this.setState((prevState) => ({
            ...prevState,
            advancedmode: !prevState.advancedmode,
        }));
        localStorage.setItem("advancedmode", JSON.stringify(!this.state.advancedmode));
    };



    message = (<React.Fragment>JSON request copied to clipboard!<br />Open and submit your request through GitHub for it to be processed.</React.Fragment>);
    render() {
        const { showModal, darkmode } = this.state;
        const COLORS = [
            "#0072B2",
            "#F0E442",
            "#CC79A7",
            "#009E73",
            "#E69F00",
            "#6a3d9a",
        ];

        const openGitHubIssueLink = () => {
            window.open(
                "https://github.com/C2SM/zonda-request/issues/new?template=data-request.md",
            );
        };

        return (
            <div className={darkmode ? "root darkmode" : "root lightmode"}>
                <Header
                    darkmode={darkmode}
                    advancedmode={this.state.advancedmode}
                    toggleDarkmode={this.toggleDarkmode}
                    toggleAdvancedmode={this.toggleAdvancedmode}
                />
                <div className="content">
                    <div className={this.state.advancedmode ? "main advancedmode" : "main"}>
                        <Templates updateState={this.updateState} />
                        <div className="divider" />
                        <h1 className={"content-title"} id="global-parameters">Global Parameters</h1>
                        <div className={"content-basic-input"}>

                            <div className={"input-section"}>
                                <div className={"section"}>RnBk Specifications and File Name</div>
                                <div className="input-content">
                                    <NKInput
                                        domains={this.state.domains}
                                        n={this.state.grid_root}
                                        k={this.state.grid_level}
                                        updateStateField={this.updateStateField}
                                    />
                                    <TextInput
                                        field={"outfile"}
                                        value={this.state.outfile}
                                        validRegex={outfile}
                                        updateStateField={this.updateStateField}
                                        tooltipMessage={"Output grid file name prefix"}
                                    />
                                </div>
                            </div>
                            {this.state.advancedmode &&
                                <div className={"icorotation-section"}>
                                    <div className={"section"}>Icorotation</div>
                                    <div className="icorotation-content">
                                        <TextInput
                                            field={"icorotation"}
                                            value={this.state.icorotation}
                                            tooltipMessage={"Additional, subsequent rotation angle (degrees) around north pole"}
                                            validRegex={lonIcoRotation}
                                            allowRegex={/^[0-9.]*$/}
                                            updateStateField={this.updateStateField}
                                        />
                                        <TextInput
                                            field={"icopole_lat"}
                                            value={this.state.icopole_lat}
                                            tooltipMessage={"Set the latitude value for base icosahedron pole rotation"}
                                            validRegex={regexCenterLat}
                                            allowRegex={/^[0-9.-]*$/}
                                            updateStateField={this.updateStateField}
                                        />
                                        <TextInput
                                            field={"icopole_lon"}
                                            value={this.state.icopole_lon}
                                            tooltipMessage={"Set the longitude value for base icosahedron pole rotation"}
                                            validRegex={lonIcoRotation}
                                            allowRegex={/^[0-9.]*$/}
                                            updateStateField={this.updateStateField}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={"divider"} />
                        <Domains
                            advancedmode={this.state.advancedmode}
                            domains={this.state.domains}
                            colors={COLORS}
                            addDomain={this.addDomain}
                            removeDomain={this.removeDomain}
                            setExtparField={this.setExtparField}
                            setIcontoolsField={this.setIcontoolsField}
                            removeIcontoolsField={this.removeIcontoolsField}
                            gridLevel={this.state.grid_level}
                            gridRoot={this.state.grid_root}
                            twoDView={this.state.twoDView}
                            updateStateField={this.updateStateField}
                        />
                        <div className={"divider"} />
                        {/*we also check for extpar_tag being set here due to the timing of component rendering,
                    we need to wait for it to be set, to correctly load the default value on the dropdown*/}
                        {
                            this.state.advancedmode && this.state.extpar_tag &&
                            <React.Fragment>
                                <h1 className={"content-title"} id="zonda-parameters">Zonda Parameters</h1>
                                <div className={"content-zonda"}>
                                    <Dropdown
                                        config={{
                                            fieldName: "extpar_tag",
                                            options: this.state.available_extpar_tags.map((tag) => ({ value: tag, label: tag })),
                                            tooltip: "choose the version of Extpar"
                                        }}
                                        setStateField={this.updateStateField}
                                        activeOptionIndex={this.state.available_extpar_tags.indexOf(this.state.extpar_tag)}
                                    />
                                </div>
                                <div className={"divider"} />
                            </React.Fragment>
                        }
                        <Request
                            state={this.state}
                            updateStateField={this.updateStateField}
                            setExtparField={this.setExtparField}
                        />

                        {
                            showModal && (
                                <Modal
                                    message={this.message}
                                    closeModal={this.closeModal}
                                    buttonAction={openGitHubIssueLink}
                                    buttonText={
                                        <>
                                            Open request <FiExternalLink style={{ marginLeft: "8px" }} />
                                        </>
                                    }
                                />
                            )
                        }
                    </div >
                    <Footer darkmode={darkmode} />
                    <Sidebar advancedmode={this.state.advancedmode} updateStateField={this.updateStateField} />
                </div>
            </div >
        );
    }
}

export default App;
